import { create } from 'zustand';

export const useSignInShellHeader = create<{
  suppressConnectTitle: boolean;
  setSuppressConnectTitle: (value: boolean) => void;
  goBackOverride: (() => void) | null;
  setGoBackOverride: (fn: (() => void) | null) => void;
}>((set) => ({
  suppressConnectTitle: false,
  setSuppressConnectTitle: (value: boolean) =>
    set({ suppressConnectTitle: value }),
  goBackOverride: null,
  setGoBackOverride: (fn: (() => void) | null) =>
    set({ goBackOverride: fn }),
}));
